import PropTypes from 'prop-types';
import { useRecordContext, useTranslate } from 'react-admin';
import CustomMorePopover from '@/components/global/buttons/CustomMorePopover';
import CustomEditModalButton from '@/components/global/buttons/CustomEditModalButton.jsx';
import CustomShowModalButton from '@/components/global/buttons/CustomShowModalButton.jsx';
import { useDrawer } from '@/composables/useDrawer';
import { ImportProductButton } from '@/components/product/buttons/ImportProductButton.jsx';

export const ProductMoreActions = ({ permissions }) => {
    const record = useRecordContext();
    const { openDrawer } = useDrawer();
    const translate = useTranslate();

    if (!record) return null;

    return (
        <CustomMorePopover permissions={permissions} record={record}>
            <CustomShowModalButton onOpen={() => openDrawer(record.id, 'product-show')} label={translate('resources.product.labels.showProduct')} />
            {permissions.isAdmin && (
                <>
                    <CustomEditModalButton onOpen={() => openDrawer(record.id, 'product-edit')} label={translate('resources.product.labels.editProduct')} />
                    <ImportProductButton id={record.id} />
                </>
            )}
        </CustomMorePopover>
    );
};

ProductMoreActions.propTypes = {
    permissions: PropTypes.shape({
        isAdmin: PropTypes.bool,
    }),
};
